var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { all, isNil, values } from 'ramda';
import { parse, stringify } from 'querystringify';
import { filterEmptyValues } from 'utils/objectHelper';
export var parseAddressQueryString = function (string) {
    if (string == null)
        return {};
    return parse(string.replace('(', '').replace(')', ''));
};
export var queryStringifyAddress = function (address) {
    return all(isNil)(values(address))
        ? null
        : "(".concat(stringify(filterEmptyValues(address), false), ")");
};
export var queryObjectValue = function (value) {
    if (value == null || value === '')
        return undefined;
    if (typeof value === 'boolean')
        return value;
    if (typeof value === 'number' && !value)
        return value;
    return String(value);
};
export var unstringifyBooleanValues = function (obj) {
    var newObj = __assign({}, obj);
    Object.keys(newObj).forEach(function (key) {
        if (newObj[key] === 'true')
            newObj[key] = true;
        if (newObj[key] === 'false')
            newObj[key] = false;
    });
    return newObj;
};
